/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { EnvService } from "namirasoft-core";
import { InvoiceCostMetaTable } from "./InvoiceCostMetaTable";
import { InvoiceItemMetaTable } from "./InvoiceItemMetaTable";
import { InvoiceMetaTable } from "./InvoiceMetaTable";
import { NSBaseMetaDatabase } from "namirasoft-site";
import { NamirasoftPaymentServer } from "../NamirasoftPaymentServer";
import { OfferItemMetaTable } from "./OfferItemMetaTable";
import { OfferMetaTable } from "./OfferMetaTable";
import { PaymentMetaTable } from "./PaymentMetaTable";
import { ProductMetaTable } from "./ProductMetaTable";
import { SalesItemMetaTable } from "./SalesItemMetaTable";
import { SubscriptionCancellationReasonMetaTable } from "./SubscriptionCancellationReasonMetaTable";
import { SubscriptionItemMetaTable } from "./SubscriptionItemMetaTable";
import { SubscriptionMetaTable } from "./SubscriptionMetaTable";
import { SubscriptionPaidMetaTable } from "./SubscriptionPaidMetaTable";
import { TokenManager } from "namirasoft-account";

export class NamirasoftPaymentMetaDatabase extends NSBaseMetaDatabase<NamirasoftPaymentServer>
{
    private manager?: TokenManager;
    private onError?: (error: Error) => void;
    public override tables: {
        invoice: InvoiceMetaTable,
        invoice_cost: InvoiceCostMetaTable,
        invoice_item: InvoiceItemMetaTable,
        offer: OfferMetaTable,
        offer_item: OfferItemMetaTable,
        payment: PaymentMetaTable,
        product: ProductMetaTable,
        sales_item: SalesItemMetaTable,
        subscription: SubscriptionMetaTable,
        subscription_cancellation_reason: SubscriptionCancellationReasonMetaTable,
        subscription_item: SubscriptionItemMetaTable,
        subscription_paid: SubscriptionPaidMetaTable,
    };
    constructor(manager?: TokenManager, onError?: (error: Error) => void)
    {
        super({ id: "prd-f66a2ebf57f149e4", name: "Namirasoft Payment", headline: "Secure Transactions Service", description: "Securely provide invoices, handle transactions, support multiple payment methods, manage subscriptions, and track payment history easily.", logo: "https://static.namirasoft.com/image/namirasoft/payment/logo/base.png", link: "https://payment.namirasoft.com" });
        this.manager = manager;
        this.onError = onError;
        this.tables = {
            invoice: new InvoiceMetaTable(this),
            invoice_cost: new InvoiceCostMetaTable(this),
            invoice_item: new InvoiceItemMetaTable(this),
            offer: new OfferMetaTable(this),
            offer_item: new OfferItemMetaTable(this),
            payment: new PaymentMetaTable(this),
            product: new ProductMetaTable(this),
            sales_item: new SalesItemMetaTable(this),
            subscription: new SubscriptionMetaTable(this),
            subscription_cancellation_reason: new SubscriptionCancellationReasonMetaTable(this),
            subscription_item: new SubscriptionItemMetaTable(this),
            subscription_paid: new SubscriptionPaidMetaTable(this),
        };
    }
    override getServer(): NamirasoftPaymentServer
    {
        if (!this.manager || !this.onError)
            throw new Error("Arguments of NamirasoftPaymentMetaDatabase (manager, onError) are required for server operations.")
        let NAME = NSBaseMetaDatabase.getServerBaseURL(this.product.name);
        let BASE_URL = new EnvService(NAME, true).getString();
        return new NamirasoftPaymentServer(BASE_URL, this.manager, this.onError);
    }
};